export default {
  namespaced: true,
  state: {
    tid: '',
    webRtcUrl: '',
    isReadyPlay: false,
  },
  mutations: {
    SET_TID(state, data) {
      state.tid = data
    },
    SET_WEBRTCURL(state, data) {
      state.webRtcUrl = data
    },
    SET_ISREADYPLAY(state, data) {
      state.isReadyPlay = data
    },
  },
}
